import { render, staticRenderFns } from "./zinara.vue?vue&type=template&id=53f839b8"
import script from "./zinara.vue?vue&type=script&lang=js"
export * from "./zinara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports